import React, { FormEvent, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { t } from 'utils';

import styles from './Radiobutton.module.scss';

export interface RadiobuttonProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  fixedLabel?: string;
  disabled?: boolean;
  value: string;
  name: string;
  onChangeAddOn?: () => void;
}

const Radiobutton: React.FC<RadiobuttonProps> = (props) => {
  const {
    label,
    disabled,
    fixedLabel,
    value,
    name,
    className,
    onChange,
    onChangeAddOn,
    ...otherProps
  } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.disabled]: disabled,
  });
  const handleChange = (e: FormEvent<HTMLDivElement>): void => {
    onChange?.(e);
    onChangeAddOn?.();
  };

  return (
    <div className={rootClassName}>
      <label>
        <input
          className='visually-hidden'
          type='radio'
          value={value}
          onChange={handleChange}
          {...otherProps}
        />
        <span className={styles.label}>{fixedLabel ?? t(label)}</span>
      </label>
    </div>
  );
};

export default Radiobutton;
